import { useEffect } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import { createPortal } from 'react-dom';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@antimatterhq/ui/components/dropdownMenu';
import {
  contextMenuStateAtom,
  closeContextMenuAtom,
} from './QueryResultsTableAtoms';

export function QueryResultsTableContextMenu() {
  const menuState = useAtomValue(contextMenuStateAtom);
  const closeMenu = useSetAtom(closeContextMenuAtom);

  useEffect(() => {
    if (!menuState.isOpen) return;

    const handleClickOutside = () => closeMenu();
    const handleScroll = () => closeMenu();

    // Add small delay to prevent immediate close on right-click
    const timer = setTimeout(() => {
      window.addEventListener('click', handleClickOutside);
      window.addEventListener('scroll', handleScroll, true);
    }, 100);

    return () => {
      clearTimeout(timer);
      window.removeEventListener('click', handleClickOutside);
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, [menuState.isOpen, closeMenu]);

  if (!menuState.isOpen || !menuState.position) {
    return null;
  }

  return createPortal(
    <div
      className="fixed z-context-menu"
      style={{
        left: `${menuState.position.x}px`,
        top: `${menuState.position.y}px`,
      }}
    >
      <DropdownMenu open={true} onOpenChange={(open) => !open && closeMenu()}>
        <DropdownMenuTrigger asChild>
          <div className="h-0 w-0" />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="start" sideOffset={4}>
          <DropdownMenuItem
            onClick={() => {
              navigator.clipboard.writeText(String(menuState.value || ''));
              closeMenu();
            }}
          >
            Copy Value
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={() => {
              navigator.clipboard.writeText(
                JSON.stringify(menuState.rowData, null, 2),
              );
              closeMenu();
            }}
          >
            Copy Row as JSON
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>,
    document.body,
  );
}
